<template>
  <authorization permissionKey="configuration_facilitator_fundoscopy" can="read">
    <v-container fluid>
      <v-row>
        <v-col class="text-h3 gray--text">
          Facilitadores da Fundoscopia
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs v-model="tab" background-color="transparent" color="secondary" show-arrows>
            <v-tab v-for="(value, key) in facilitatorTypes" :key="key">
              {{ value }}
            </v-tab>
          </v-tabs>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-tabs-items v-model="tab">
            <v-tab-item v-for="(value, key) in facilitatorTypes" :key="key">
              <ConfigFundoscopyList
                :facilitators="fundoscopyFacilitators"
                :facilitatorType="key"
                :refreshList="refreshList"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-col>
      </v-row>
    </v-container>
  </authorization>
</template>

<script>
  import ConfigFundoscopyList from "@/components/config/fundoscopy/index.vue";

  export default {
    name: "FundoscopyFacilitators",
    components: {
      ConfigFundoscopyList,
    },
    data() {
      return {
        tab: null,
        facilitatorTypes: {
          site: "Local",
          visibility: "Visibilidade",
          vitreo: "Vitreo",
          pappila: "Papila",
          vaso: "Vaso",
          retina: "retina",
          macula: "macula",
          intensity: "Intensidade",
        },
      };
    },
    apollo: {
      fundoscopyFacilitators: {
        query: require("@/graphql/fundoscopy/fundoscopy_facilitators.gql"),
      },
    },
    methods: {
      refreshList() {
        this.$apollo.queries.fundoscopyFacilitators.refetch();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
